import {
  GlobalWorkerOptions,
  getDocument,
  version,
} from "pdfjs-dist/legacy/build/pdf.js";
// import { pdfjs } from "react-pdf";
// import pdfWorker from "./pdfWorker";
import { pdfProtectionStates } from "../../../../interfaces/interfaces";
import { Moment } from "moment";
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
// GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

// console.log("pdf js version", version);

export const checkPDFProtection = async (
  file: File,
  password: string = ""
): Promise<string> => {
  if (!file) return "No file provided.";

  // Read the file as an ArrayBufferr
  const arrayBuffer = await file.arrayBuffer();

  try {
    // Create a loading task with the provided data and password.
    const loadingTask = getDocument({ data: arrayBuffer, password });

    // Await the loadingTask promise.
    await loadingTask.promise;

    // If the promise resolves, the PDF is unlocked.
    return !password
      ? pdfProtectionStates.passwordNotRequired
      : pdfProtectionStates.passwordValidated;
  } catch (error: any) {
    // Handle the specific case for password protection.
    if (error.name === "PasswordException") {
      return password
        ? pdfProtectionStates.passwordValidationFailed
        : pdfProtectionStates.passwordRequired;
    } else {
      // For any other errors, return a generic error message.
      return pdfProtectionStates.errorProcessing;
    }
  }
};

export const addDelay = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const getRestrictedIpDataPeriod = (
  yesterdayDate: Moment,
  configValue: string
) => {
  const endDate = yesterdayDate.clone();

  const normalized = configValue.trim().toUpperCase().replace(/[-\s]/g, "_");
  const match = normalized.match(/LAST_(\d+)_([A-Z]+)/);

  const amount = parseInt(match[1], 10);
  const unitRaw = match[2];

  const unitMap: Record<string, moment.unitOfTime.DurationConstructor> = {
    DAYS: "days",
    DAY: "days",
    MONTHS: "months",
    MONTH: "months",
    YEARS: "years",
    YEAR: "years",
    WEEKS: "weeks",
    WEEK: "weeks",
  };

  const unit = unitMap[unitRaw];

  let startDate = endDate.clone().subtract(amount, unit);

  if (unit === "months" || unit === "years") {
    startDate = startDate.startOf("month");
  }

  return {
    key: configValue,
    startDate: startDate,
    endDate: endDate,
  };
};

export const getMaxDataPeriod = (
  configValues: string[],
  yesterdayDate: Moment
): { key: string; start: string; end: string } => {
  const allPeriods = configValues.map((value) =>
    getRestrictedIpDataPeriod(yesterdayDate, value)
  );

  const max = allPeriods.reduce((minPeriod, current) => {
    return current.startDate.isBefore(minPeriod.startDate)
      ? current
      : minPeriod;
  });

  return {
    key: max.key,
    start: max.startDate.format("DD-MM-YYYY"),
    end: max.endDate.format("DD-MM-YYYY"),
  };
};
